import UserAvatar from "../../components/global/avtar/UserAvatar";

const formatCurrency = (value) =>
  value != null
    ? `$ ${Number(value).toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })}`
    : "--";

const columns = [
  {
    title: "User",
    dataIndex: "userDetails",
    key: "userDetails",
    sorter: true,
    render: (_, record) => (
      <UserAvatar
        data={{
          name: record?.name ?? "--",
          email: record?.email,
        }}
      />
    ),
  },
  {
    title: "Wallet Balance",
    dataIndex: "walletBalance",
    key: "walletBalance",
    sorter: true,
    render: formatCurrency,
  },
  {
    title: "IB Wallet Balance",
    dataIndex: "ibWalletBalance",
    key: "ibWalletBalance",
    sorter: true,
    render: formatCurrency,
  },
  {
    title: "IB Commission",
    dataIndex: "ibCommission",
    key: "ibCommission",
    sorter: true,
    render: formatCurrency,
  },
  {
    title: "User Type",
    dataIndex: "isIBUser",
    key: "isIBUser",
    sorter: true,
    render: (value) =>
      value ? (
        <span className="px-3 py-1 rounded-full uppercase text-xs text-center success_tag">
          IB
        </span>
      ) : (
        <span className="px-3 py-1 rounded-full uppercase text-xs text-center bg-sky-500/10 text-sky-600">
          User
        </span>
      ),
  },
];

export default columns;
